// extracted by mini-css-extract-plugin
export var backdrop = "ModalDialog-module--backdrop--68f74";
export var closeIcon = "ModalDialog-module--closeIcon--557a1";
export var container = "ModalDialog-module--container--2ea2d";
export var imageContainer = "ModalDialog-module--imageContainer--057ca";